import React, { useState, useEffect, useRef } from 'react';
import image1 from '../../assets/images/home/hompage/s1.png';
import image2 from '../../assets/images/home/hompage/s2.png';
import image3 from '../../assets/images/home/hompage/s3.png';
import image4 from '../../assets/images/home/hompage/s4.png';
import image5 from '../../assets/images/home/hompage/s5.png';
import image6 from '../../assets/images/home/hompage/s6.png';
import image7 from '../../assets/images/home/hompage/s7.png';

import mobsports1 from '../../assets/images/home/hompage/mobcricket1.png';
import mobsports2 from '../../assets/images/home/hompage/mobfootball2.png';
import mobsports3 from '../../assets/images/home/hompage/mobtennis3.png';
import mobsports4 from '../../assets/images/home/hompage/mobbasketball4.png';
import mobsports5 from '../../assets/images/home/hompage/mobbadminton5.png';
import mobsports6 from '../../assets/images/home/hompage/mobicehockey6.png';




import './Sportscontainer.scss';
import { useSelector } from 'react-redux';
import { RootState } from '../../models/RootState';
import { useHistory } from 'react-router';

interface GamesContainerProps {
  title: string;
  gameList: any[];
}

const Sportscontainer: React.FC<GamesContainerProps> = ({ title, gameList }) => {
  const loggedIn = useSelector((state: RootState) => state.auth.loggedIn);
    const langData=useSelector((state:RootState)=> state.common.langData)
  const [dialogShow, setDialogShow] = useState<boolean>(false);
  // const [selectedCategory, setSelectedCategory] = useState(tabs);
  const [gamesDisplay, setGamesDisplay] = useState([]);
  const [activeCategory, setActiveCategory] = useState<string | null>(
    'Originals'
  );

  const history = useHistory();

  const handleClick = ()=>{
  history.push('/premium_sports');
}
  // const navigate = useNavigate();
  const gamesContainerRef = useRef<HTMLDivElement>(null);

 
  return (
    <div className="games-container">
      <div className="games-container-card">
        <div className="games-header">
          <div className="categories-container">
            <div className="category-item">{title}</div>
            <div className="gradient-line"></div>
          </div>
       
        </div>
        <div className="sports-display web-view">
            <div className='comp comp-s1' onClick={() => history.push('/premium_sports?sportId=21')}>
            <img loading="lazy" className="casino-img" src={image1} />
            </div>
            <div className='comp comp-s2'>
                <div className='comp-21' onClick={() => history.push('/premium_sports?sportId=1')}>
                <img loading="lazy"  className="casino-img-2" src={image2} />
                </div>
                <div className='comp-22' onClick={() => history.push('/premium_sports?sportId=5')}>
                <img loading="lazy"  className="casino-img-2" src={image3} />
                </div>
            </div>
            <div  className='comp comp-s3' onClick={() => history.push('/premium_sports?sportId=2')} >
                <img loading="lazy" className="casino-img" src={image4} />
            </div>
            <div className='comp comp-s4'>
                <div className='comp-41' onClick={() => history.push('/premium_sports?sportId=31')}>
                <img loading="lazy"  className="casino-img-2" src={image5} />
                </div>
                <div className='comp-42' onClick={() => history.push('/premium_sports?sportId=3')}>
                <img loading="lazy"  className="casino-img-2" src={image6} />
                </div>
            </div>
            <div className='comp comp-s5' onClick={() => history.push('/premium_sports?sportId=4')}>
                <img loading="lazy" className="casino-img" src={image7} />
            </div>
            {/* <div>
            <img loading="lazy" src={sportsimg} />
            </div> */}
        </div>
        <div className="mobsports-display mob-view">
            <div className='mobcomp-s1'>
              <div className='mobsport-11 comp-cursor' onClick={() => history.push('/premium_sports?sportId=21')}>
            <img loading="lazy" className='mob-inmage' src={mobsports1} />
            </div>

                <div className='mobsport-12 comp-cursor' onClick={() => history.push('/premium_sports?sportId=31')}>
                <img loading="lazy" className='mob-inmage' src={mobsports5} />
                </div>
                <div className='mobsport-13 comp-cursor' onClick={() => history.push('/premium_sports?sportId=4')}>
                <img loading="lazy" className='mob-inmage' src={mobsports6} />
                </div>
            </div>
            <div className='mobcomp-s2'>
              <div className='mobsport-21 comp-cursor' onClick={() => history.push('/premium_sports?sportId=5')}>
                <img loading="lazy" className='mob-inmage'  src={mobsports3} />
            </div>
                <div className='mobsport-22 comp-cursor' onClick={() => history.push('/premium_sports?sportId=1')}>
                <img loading="lazy" className='mob-inmage' src={mobsports2} />
                </div>
                <div className='mobsport-23 comp-cursor' onClick={() => history.push('/premium_sports?sportId=2')}>
                <img loading="lazy" className='mob-inmage' src={mobsports4} />
                </div>
          

          
        </div>
        </div>
      </div>
    </div>
  );
};

export default Sportscontainer;
